// tslint:disable-next-line:no-duplicate-imports
// @ts-ignore
import * as _moment from 'moment-timezone';
import { default as _rollupMoment } from 'moment-timezone';

export const moment = _rollupMoment || _moment;
